import React from 'react';
import { IoMdMicrophone } from 'react-icons/io';
import { FaRegClock } from 'react-icons/fa';
import EventContainer from './EventContainer';

/**
 * Full primary view for upcoming events/meetings — same data and behavior as
 * {@link EventContainer} in the schedule sidebar, optimized for the main content area.
 */
export default function ScheduleEventsView({
    canViewMeetings = false,
    eventPanelEntryType = 'event',
    onEventPanelEntryTypeChange,
    ...eventContainerProps
}) {
    const entryType = canViewMeetings ? eventPanelEntryType : 'event';

    return (
        <div className="flex flex-col min-h-0 h-full w-full gap-3 px-1 sm:px-2">
            {canViewMeetings && typeof onEventPanelEntryTypeChange === 'function' && (
                <div className="flex w-full max-w-2xl mx-auto rounded-lg border border-gray-200 bg-white shadow-sm overflow-hidden shrink-0">
                    <button
                        type="button"
                        onClick={() => onEventPanelEntryTypeChange('event')}
                        className={`flex-1 min-w-0 whitespace-nowrap px-3 py-2 text-sm flex items-center justify-center gap-2 transition-colors ${entryType === 'event'
                            ? 'bg-blue-50 text-blue-700 font-semibold'
                            : 'text-gray-600 hover:bg-gray-50'}`}
                        aria-pressed={entryType === 'event'}
                    >
                        <IoMdMicrophone className="w-4 h-4" />
                        Events
                    </button>
                    <button
                        type="button"
                        onClick={() => onEventPanelEntryTypeChange('meeting')}
                        className={`flex-1 min-w-0 whitespace-nowrap px-3 py-2 text-sm flex items-center justify-center gap-2 transition-colors border-l border-gray-200 ${entryType === 'meeting'
                            ? 'bg-blue-50 text-blue-700 font-semibold'
                            : 'text-gray-600 hover:bg-gray-50'}`}
                        aria-pressed={entryType === 'meeting'}
                    >
                        <FaRegClock className="w-4 h-4" />
                        Meetings
                    </button>
                </div>
            )}
            <div className="flex-1 min-h-0 overflow-auto">
                <EventContainer
                    {...eventContainerProps}
                    entryType={entryType}
                    layout="page"
                    showTitle
                    panelTitle={entryType === 'meeting' ? 'Upcoming Meetings' : 'Upcoming Events'}
                    emptyMessage={entryType === 'meeting' ? 'No upcoming meetings.' : 'No upcoming events.'}
                    addButtonLabel={entryType === 'meeting' ? 'Add New Meeting' : 'Add New Event'}
                    documentationId={entryType === 'meeting' ? 'meetings' : 'events'}
                />
            </div>
        </div>
    );
}
